import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { faqs, trustPoints } from '@/mocks/homeData';

export default function FaqTrust() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="bg-background-50">
      <div className="mx-auto w-full max-w-shell px-4 py-20 md:px-6 md:py-28">
        <Reveal>
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full border border-secondary-300/70 bg-secondary-50 px-3 py-1 text-xs font-medium text-secondary-800">
              <i className="ri-shield-check-line" />
              吃瓜须知
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              先说清楚我们怎么做的，你再决定信多少
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              一个一直在更新的站点，最该讲明白的就是：内容从哪来、错了怎么办、边界在哪。下面这几点，比任何一条爆料都重要。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1">
              {trustPoints.map((point, index) => (
                <Reveal key={point.title} delay={index * 70}>
                  <div className="flex gap-4 rounded-lg border border-background-200/80 bg-background-100 p-5">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                      <i className={`${point.icon} text-lg`} />
                    </span>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 md:text-base">{point.title}</h3>
                      <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-sm">{point.text}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={80}>
              <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">常见问题</h3>
              <ul className="mt-6 border-t border-background-200/80">
                {faqs.map((faq, index) => {
                  const isOpen = openIndex === index;
                  return (
                    <li key={faq.q} className="border-b border-background-200/80">
                      <button
                        type="button"
                        onClick={() => toggle(index)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 py-5 text-left transition-colors hover:text-primary-700"
                      >
                        <span className="flex items-start gap-3 font-heading text-sm font-semibold text-foreground-950 md:text-base">
                          <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xs text-primary-800">
                            {String(index + 1).padStart(2, '0')}
                          </span>
                          {faq.q}
                        </span>
                        <i
                          className={`ri-add-line shrink-0 text-lg text-foreground-400 transition-transform duration-300 ${
                            isOpen ? 'rotate-45' : ''
                          }`}
                        />
                      </button>
                      <div
                        className={`grid overflow-hidden transition-all duration-300 ${
                          isOpen ? 'grid-rows-[1fr] pb-5 opacity-100' : 'grid-rows-[0fr] opacity-0'
                        }`}
                      >
                        <p className="min-h-0 pl-9 pr-4 text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </Reveal>

            <Reveal delay={120}>
              <div className="mt-8 flex flex-col gap-4 rounded-lg bg-foreground-950 p-6 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <p className="font-heading text-base font-semibold text-background-50">
                    看完整个最新动态，从时间线开始更省事
                  </p>
                  <p className="mt-1 text-xs text-background-100/70">
                    热点区负责快，时间线负责全，两边对着看不容易漏。
                  </p>
                </div>
                <a
                  href="#timeline"
                  className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
                >
                  <i className="ri-history-line text-base" />
                  回到时间线
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}